<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;">
        <div style="display: flex;margin-bottom: 10px;">
			<el-input placeholder="用户手机" v-model="search.phone" size="small" style="width: 150px;margin-left: 10px;"/>
            <el-cascader v-model="search.depart" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" style="width: 200px;margin-left: 10px;" size="small" @visible-change="getDepartmentLists" placeholder="选择部门 "></el-cascader>
			<!-- <el-input placeholder="所属员工手机" v-model="search.admin_phone" size="small" style="width: 150px;margin-left: 10px;"/> -->
            <el-select v-model="search.admin_id" clearable filterable size="small" placeholder="员工账号" style="margin-left: 10px;" @visible-change="selectAdmin">
                <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
            </el-select>
			<el-button size="small" style="margin-left: 10px;" @click="getList(1)">筛选</el-button>
			<el-button size="small" type="warning" v-permit="'/admin/crm/blacklistGet'" @click="ruleOpen">限制规则</el-button>
			<el-button size="small" type="success" v-permit="'/admin/crm/blacklistAdd'" @click="openadd">加入黑名单</el-button>
		</div>
        <el-table :data="list" v-loading="tableLoading" stripe :header-cell-style="{ background:'#f5f5f5'}" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55"></el-table-column>
            <el-table-column prop="id" label="用户信息">
                <template v-slot="{row}">
                    <p><span class="_color">编号：</span>{{row.id}}</p>
                    <p><span class="_color">姓名：</span>{{row.name}} {{row.phone}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="所属部门">
                <template v-slot="{row}">
                    <p><span class="_color">部门：</span>{{row.depart_name}}</p>
                    <p><span class="_color">员工：</span>{{row.admin ? row.admin.nick_name : ''}} {{row.admin ? row.admin.phone : ''}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="限制">
                <template v-slot="{row}">
                    <p><span class="_color">限制：</span>{{row.blacklist ? row.blacklist.created_time : ''}}</p>
                    <p><span class="_color">原因：</span>{{row.blacklist ? row.blacklist.remark : ''}}</p>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="110px" align="center">
                <template v-slot="{row}">
                    <el-button type="danger" size="small" v-permit="'/admin/crm/blacklistDel'" @click="del([row.id])">解除限制</el-button>
                </template>
            </el-table-column>
        </el-table>
		
		<el-dialog title="限制规则" :visible="ruleVisible"  width="900px"  center @close="ruleVisible=false">
			<div class="pl_20">
				<el-checkbox v-model="ruleForm.crm_blacklist_switch" true-label="1" false-label="0">客户黑名单</el-checkbox>
				<div class="_flex _f_ai _f_fw ml_30 mb_20">
					如某客户订单被拒签
					<el-input v-model="ruleForm.crm_blacklist_reject_times" size="small" style="width: 100px;margin: 0 10px;"/>
					单，则将该客户列入黑名单,禁止为其下单
				</div>
				<el-checkbox v-model="ruleForm.crm_blacklist_hit_switch" true-label="1" false-label="0">撞单入单限制</el-checkbox>
				<div class="_flex _f_ai ml_30">
					为某客户入单时，如在近7天中，有由不同业务员的下单记录，则限制本次入单
				</div>
			</div>
            <div style="padding-left: 20px;margin-top: 10px;">
                <el-checkbox v-model="ruleForm.crm_order_limit_switch" true-label="1" false-label="0">录单限制</el-checkbox>
				<div style="margin-left: 30px;;">
					如某客户在近 
                    <el-input v-model="ruleForm.crm_order_limit_days" size="small" style="width: 80px;margin: 0 6px;"/> 
                    天时间内，有指定商品类型为
                    <el-select v-model="ruleForm.crm_order_limit_good_type" size="medium" filterable clearable multiple placeholder="商品类型" style="width: 250px;margin: 0 6px;">
                        <el-option label="标准单" value="1" />
                        <el-option label="定制单" value="4" />
                        <el-option label="礼品单" value="5" />
                        <el-option label="赠品单" value="6" />
                    </el-select>
                    的历史订单，则禁止为该客户再次录入
                    <el-select v-model="ruleForm.crm_order_limit_type" size="medium" filterable clearable placeholder="订单类型" style="width: 100px;margin: 0 6px;">
                        <el-option label="标准单" value="1" />
                        <el-option label="定制单" value="4" />
                        <el-option label="礼品单" value="5" />
                        <el-option label="赠品单" value="6" />
                    </el-select>
                    类型的订单
				</div>
            </div>
            <span slot="footer">
                <el-button type="" @click="ruleVisible = false">取 消</el-button>
                <el-button type="primary" v-permit="'/admin/crm/blacklistSet'" @click="ruleSubmit">确 定</el-button>
            </span>
		</el-dialog>

        <el-dialog title="加入黑名单" :visible="addVisible"  width="700px"  center @close="addVisible=false">
			<div class="pl_20">
				<div class="mb_20">将指定用户手动加入黑名单</div>
				<div class="_flex _f_ai _f_fw mb_20">
					用户手机号：
					<el-input v-model="addForm.phone" size="small" style="width: 150px;margin: 0 10px;"/>
                    <el-button type="success" size="mini" :loading="addLoading" @click="find">{{addLoading ? '查找中' : '查找'}}</el-button>
				</div>
				<div class="bag_d p_10 br_8 mt_10" style="cursor: pointer;"
                    v-for="item in addForm.userArr" :key="item.id" 
                    :style="{border: addForm.id == item.id ? '1px solid' : 'none'}"
                    @click="addForm.id = item.id"
                >
                    <p>
                        <span class="_color">编号：</span>{{item.id}}
                        <span class="ml_20 mr_5 _color">用户：</span>{{item.name}} {{item.phone}}
                    </p>
                    <p class="pt_10"><span class="_color">地址: </span>{{item.province_name}}{{item.city_name}}{{item.area_name}}{{item.street_name}}{{item.address}}</p>
				</div>
				<div class="_flex _f_ai _f_fw mt_20">
					原因备注:<el-input v-model="addForm.remark" style="width: 500px;margin-left: 10px;"/>
				</div>
			</div>
            <span slot="footer">
                <el-button type="" @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addSubmit">确 定</el-button>
            </span>
		</el-dialog>
		
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <div>
            <el-button size="small" type="danger">清空选择（{{selectedUsers.length}}）</el-button>
            <el-dropdown @command="handleCommand" style="margin-left: 10px;">
                <el-button size="small" type="primary">批量操作 ></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1" v-permit="'/admin/crm/blacklistDel'">解除限制</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div style="margin-left: auto;">
            <el-pagination background @size-change="changeLimit" @current-change="changePage" :current-page="search.page" :page-size="search.limit" layout="total, sizes, prev, pager, next, jumper" :total="search.total" :page-sizes="[10, 50, 100, 500]"></el-pagination>
        </div>
    </el-footer>
</el-container>
</template>
<script>
import { userLists, blacklistGet, blacklistSet, blacklistAdd, blacklistDel, DepartmentLists, adminLists } from "@/request/apis.js"
export default{
    data(){
        return {
            tableLoading: false,
            selectedUsers: [],
            search: {
                page: 1,
                limit: 10,
                total: 0,
                in_blacklist: 1,
                phone: '',
                admin_phone: '',
                admin_id: '',
                depart: [],
            },
			tabType : '1',
			alertType : 0,
			name:'',
			searchShow:false,
            list : [],
			formData : {
				name : ''
			},
            ruleVisible: false,
            ruleForm: {
                crm_blacklist_switch: 0,
                crm_blacklist_reject_times: '',
                crm_blacklist_hit_switch: 0,
                crm_order_limit_switch: 0,
                crm_order_limit_days: '',
                crm_order_limit_good_type: [],
                crm_order_limit_type: '',
            },
            addVisible: false,
            addLoading: false,
            addFormInit: {},
            addForm: {
                phone: '',
                userArr: [],
                id: 0,
                remark: '',
            },
            adminList: [],
            departArr: [],
        }
    },
	mounted() {
        this.addFormInit = {...this.addForm};
		this.getList()
	},
	methods:{
        async getList(page){
            if (page) {
                this.search.page = page;
            }
            this.tableLoading = true;
            var res = await userLists(this.search);
            this.tableLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.search.total = res.count;
        },
        changeLimit(limit){
            this.search.limit = limit;
            this.getList(1);
        },
        changePage(page){
            this.getList(page);
        },
        async selectAdmin(query){
            if (!query) {
                return false;
            }
            const res = await adminLists({limit: 1000})
            if (res.code) {
                return this.$message.error(res.msg)
            }
            this.adminList = res.data;
        },
        async getDepartmentLists(){
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
        },
        handleSelectionChange(selection) {
            this.selectedUsers = selection;
        },
        async ruleOpen(){
            var res = await blacklistGet();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.ruleForm = {...this.ruleForm, ...res.data};
            this.ruleVisible = true;
        },
        async ruleSubmit(){
            var res = await blacklistSet(this.ruleForm);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.ruleVisible = false;
        },
        async find(){
            if(this.addForm.phone.length < 7){
                return this.$message.error('请输入至少七位手机号');
            }
            this.addLoading = true;
            var res = await userLists({phone: this.addForm.phone});
            this.addLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.addForm.userArr = res.data;
            if(res.data.length == 1){
                this.addForm.id = res.data[0].id;
            }
        },
        openadd(){
            this.addForm = {...this.addFormInit};
            this.addVisible = true;
        },
        async addSubmit(){
            if(!this.addForm.id){
                return this.$message.error('请通过用户手机号选择加入黑名单的用户');
            }
            if(!this.addForm.remark.length){
                return this.$message.error('请设置原因备注信息');
            }
            var res = await blacklistAdd(this.addForm);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.addVisible = false;
            this.getList();
        },
        del(ids){
            this.$confirm('确定解除限制吗? 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var res = await blacklistDel({ids});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.getList();
            }).catch(() => { });
        },
		handleCommand(e){
            if(this.selectedUsers.length == 0){
                return this.$message.error('请先选择数据');
            }
			if(e == 1){
                this.del(this.selectedUsers.map(v => v.id));
            }
		}
		
	}
}
</script>

<style  scoped>
p{margin: 0;}
.detail_form ::v-deep .el-form-item{
	height: 36px;
	margin-bottom: 15px;
}
::v-deep.el-popover{
	min-width: 60px!important;
}
</style> 